import {Link} from 'react-router-dom';
import React from 'react';
import styled from 'styled-components';

import Copyright from './Copyright';
import Logout from './Logout';
import constants from '../parameters/constants';

export const NaviItem = styled.div`
  line-height: 50px;
  font-size: 25px;
  font-weight: 200;
  cursor: pointer;
  a,
  a:hover {
    color: ${constants.complementaryColor};
    text-decoration: none;
  }
`;
export const LogoutItem = styled(NaviItem)`
  margin-top: 80px;
  color: ${constants.complementaryColor};
`;

const NexGroupNavItem = styled(NaviItem)`
  margin-top: 60px;
`;

const NavCopyright = styled(NaviItem)`
  line-height: 1;
  position: absolute;
  bottom: 5px;
  left: 25px;
  color: #fff;
`;

const Wrapper = styled.div`
  padding-top: 150px;
`;

export const sidebarContent = ({role}) => (
  <Wrapper>
    <NexGroupNavItem>
      <Link to={'/users'}>Benutzer</Link>
    </NexGroupNavItem>

    <Logout />
    <NavCopyright>
      <Copyright />
    </NavCopyright>
  </Wrapper>
);
export const sidebarStyles = {
  root: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: 'hidden',
  },
  sidebar: {
    zIndex: 2500,
    position: 'absolute',
    top: 0,
    bottom: 0,
    transition: 'transform .3s ease-out',
    WebkitTransition: '-webkit-transform .3s ease-out',
    willChange: 'transform',
    overflowY: 'auto',
    background: '#454849',
    padding: 40,
    minWidth: 250,
  },
  content: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflowY: 'scroll',
    WebkitOverflowScrolling: 'touch',
    transition: 'left .3s ease-out, right .3s ease-out',
  },
  overlay: {
    zIndex: 2,
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: 0,
    visibility: 'hidden',
    transition: 'opacity .3s ease-out, visibility .3s ease-out',
    backgroundColor: 'rgba(0,0,0,.3)',
  },
  dragHandle: {
    zIndex: 1,
    position: 'fixed',
    top: 0,
    bottom: 0,
  },
};



// WEBPACK FOOTER //
// ./src/components/SidebarContent.js